import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

export default function ProtectedRoute() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Wait for Firebase to restore the persisted session before deciding.
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-neutral-50 dark:bg-neutral-950 text-neutral-400 dark:text-neutral-500">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Remember where the user was headed so we can return them after sign-in.
    return <Navigate to="/auth/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return <Outlet />;
}
